export const resources = {
  LanguagesLoadingFailErrorMsg: ''
};
